export const addLeadingSlash = (path: string): string => (path.charAt(0) === '/' ? path : `/${path}`);

export const stripLeadingSlash = (path: string): string => (path.charAt(0) === '/' ? path.substr(1) : path);

export const hasBasename = (path: string, prefix: string): boolean =>
    new RegExp(`^${prefix}(\\/|\\?|#|$)`, 'i').test(path);

export const stripBasename = (path: string, prefix: string): string =>
    hasBasename(path, prefix) ? path.substr(prefix.length) : path;

export const stripTrailingSlash = (path: string): string =>
    path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
